<template lang="html">
  <div class="container-fluid p-1 p-lg-5 mt-3">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Notification List
          </div>
          <div class="card-body">
            <!-- <div class="row">
              <div class="col-md-12">
                <div class="row search-form">
                  <div class="col-md-3 mt-1 d-none">
                    <input
                      type="text"
                      v-model="filter.title"
                      class="form-control"
                      placeholder="Name"
                    />
                  </div>
                  <div class="col-md-3 mt-1 d-none">
                    <input
                      onfocus="(this.type='date')"
                      v-model="filter.from_date"
                      class="form-control"
                      placeholder="From Date"
                      @change="validationRule()"
                    />
                  </div>
                  <div class="col-md-3 mt-1 d-none">
                    <input
                      onfocus="(this.type='date')"
                      v-model="filter.to_date"
                      class="form-control"
                      placeholder="To Date"
                      @change="validationRule()"
                    />
                  </div>
                  <div class="col-md-3 mt-1 d-none">
                    <button
                      class="btn btn-primary mr-1 fbutton"
                      @click="search()"
                    >
                      <i class="fas fa-search"></i> Search
                    </button>
                    <button class="btn btn-info fbutton" @click="reset()">
                      <i class="fas fa-sync"></i> Reset
                    </button>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="row mt-2">
              <div class="col-md-12">
                <div class="table-responsive mt-4">
                  <table class="common-table">
                    <thead>
                        <tr>
                            <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                {{ value }}
                                <span v-if="filter.sortKey === key">
                                    <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                    <i v-else class="fas fa-sort-down"></i>
                                </span>
                            </th>
                            <th>Notification</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in dataList">
                        <td>{{ data.title }}</td>
                        <td>{{ truncateText(data?.short_description || "", 10) }}</td>
                        <td>{{ truncateText(data.body, 10) }}</td>
                        <td class="text-capitalize">{{ data.createdDate }}</td>
                        <td>
                          <button
                            v-b-modal.bv-modal-status
                            class="btn btn-success btn-sm"
                            @click="sendNotificationModal(data)"
                          >
                            <i class="fas fa-paper-plane"></i> Send
                          </button>
                        </td>
                        <td style="padding: 0px;">
                          <button
                            class="btn btn-option text-primary"
                            @click="editData(data)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            v-b-modal.bv-modal-delete
                            class="btn btn-option text-danger"
                            @click="deleteModal(data)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="dataList.length <= 0">
                        <td colspan="8" class="text-center">Empty List</td>
                      </tr>
                    </tbody>
                  </table>
                      <div class="table-pagination-minimal">
                        <div class="table-pagination-row">
                          <div v-if="dataList.length > 0 " class="table-info-minimal">
                              Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                          </div>
                          <nav class="pagination-minimal">
                              <ul>
                                  <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                      <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                          <i class="fas fa-angle-left"></i>
                                      </button>
                                  </li>
                                  <li v-for="page in metaData.last_page" :key="page"
                                      :class="{ 'active':metaData.current_page === page }"
                                      v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                      <button @click.prevent="next(page)">{{ page }}</button>
                                  </li>
                                  <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                      <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                          <i class="fas fa-angle-right"></i>
                                      </button>
                                  </li>
                              </ul>
                          </nav>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="bv-modal-status"
      ref="send-modal"
      title="Default Status"
      hide-footer
    >
      <p class="my-4">Are you sure to send notification ?</p>
      <p class="my-4 text-danger">{{ alert }}</p>
      <b-button class="mt-3 btn-success" block @click="sendNotification()"
        >Send</b-button
      >
    </b-modal>
    <b-modal id="bv-modal-delete" ref="delete-modal" title="Delete" hide-footer>
      <p class="my-4">Are you sure to delete ?</p>
      <p class="my-4 text-danger">{{ alert }}</p>
      <b-button class="mt-3 btn-danger" block @click="deleteItem(data)"
        >Delete</b-button
      >
    </b-modal>
    <b-modal
      id="bv-modal-success"
      ref="successModal"
      title="Success"
      hide-footer
    >
      <p class="my-4 text-success">Successfully Send Notification !</p>
    </b-modal>
    <router-link class="float" to="notification-create">
      <i class="fa fa-plus my-float" style="padding: 37%;"></i>
    </router-link>
  </div>
</template>
<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
import env from '../../enviorments'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'orgNameList',
    metaInfo: {
        title: "Notification",
        titleTemplate: "%s ← List",
    },
    components: {
        Loading
    },
    data() {
        return {
            env,
            isLoading: false,
            fullPage: true,
            alert: "",
            id: '',
            dataList: [],
            permissions: '',
            columns: {
                title: "Title",
                short_description:"Short Description",
                body: "Body",
                created_at: "Created Date",

            },
            filter: {
                page: 1,
                limit: 10,
            },
            metaData: {
                last_page: null,
                current_page: 1,
                from: null,
                to: null,
                total: null,
                prev_page_url: null
            }
        }
    },
    watch: {
        '$route'(to, from) {
            this.fetchData()
        }
    },
    computed: {},
    methods: {
        ...mapActions({
            notiListAction: 'notiListAction',
            notificationSendAction: 'notificationSendAction',
            notiDeleteAction: 'notiDeleteAction',
            notiSendAction:"notiSendAction"
        }),
        truncateText(html, limit) {
          const text = html.replace(/<[^>]+>/g, ''); // remove HTML tags
          return text.length > limit ? text.slice(0, limit) + '…' : text;
        },
        sortBy(column) {
            this.filter.sortKey = column
            if (this.filter.sortKey == column) {
                if (this.filter.orderBy == "asc") {
                    this.filter.orderBy = "desc"
                } else if (this.filter.orderBy == "desc") {
                    this.filter.orderBy = "asc"
                }
            } else {
                this.filter.orderBy = "asc"
            }
            this.fetchData()
        },
        async search() {
            this.filter.page = 1
            this.fetchData()
            this.$refs['send-modal'].hide()
        },
        async goToCreate() {
            this.$router.replace({
                path: "/notification-create"
            })
        },
        async fetchData() {
            this.isLoading = true
            let option = this.filter;
            await this.notiListAction(option).then(res => {

                if (res.success === true) {
                    this.dataList = res.data.data;
                    this.metaData.last_page = res.data.meta.lastPage;
                    this.metaData.current_page = res.data.meta.currentPage;
                    this.metaData.prev_page_url = res.data.meta.prePage;
                    this.metaData.from = res.data.meta.from
                    this.metaData.to = res.data.meta.to
                    this.metaData.total = res.data.meta.total
                    this.$router.replace({
                        path: 'notification-list',
                        query: {
                            page: this.filter.page,
                        }
                    }).catch(() => {})
                    this.isLoading = false;
                }
            })
        },
        next: function(page) {
            this.filter.page = page
            this.fetchData();
        },
        reset() {
            this.$router.replace({
                path: 'notification-list',
                query: {
                    page: 1,
                    orderBy: 'desc',
                    sortKey: 'created_at',
                    title: '',
                    from_date: '',
                    to_date: '',
                }
            }).catch(() => {})
            this.$router.go()
        },
        editData(data) {
            this.$router.replace({
                path: 'notification-edit',
                query: {
                    id: data.id,
                    page: this.metaData.current_page,
                    title: data.title,
                    body: data.body,
                }
            }).catch(() => {})
        },
        async sendNotificationModal(data){
          this.id = data.id;
        },  
        async sendNotification(){
          this.isLoading = true
          let option = {
            id:this.id
          }
            await this.notiSendAction({
              ...option
            }).then(res => {
              if(res.success = false){
                this.alert = res.message
              }else{
                this.$refs['send-modal'].hide()
                this.$refs.successModal.show();
                setTimeout(() => {
                        this.$refs.successModal.hide();
                  }, 3000)
              }
              this.isLoading = false
            }).catch(err => {
                if (err.response.data.message) {
                    this.alert = err.response.data.message
                }
                this.isLoading = false
            })
          },
        async deleteModal(data){
          this.id = data.id;
        },  
        async deleteItem() {
            this.isLoading = true
            let option = {
                id: this.id,
            }
            await this.notiDeleteAction({
                ...option
            }).then(res => {
                if (res.success == false) {
                    this.alert = res.message;
                    return;
                } else {
                  this.$refs['delete-modal'].hide()
                }
                this.fetchData()
                this.isLoading = false;
            }).catch(err => {
                if (err.response.data.message) {
                    this.alert = err.response.data.message
                }
                this.isLoading = false
            })
        },
        checkPermission: function(key) {
            if (key in this.permissions) {
                return true
            } else {
                return false
            }
        }

    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem('user'))
        this.permissions = user.permissions
        this.filter.page = this.$route.query.page
        this.fetchData()
    }
}
</script>

<style scoped lang="scss">
.action {
  border: none;
  background: none;
  font-size: 24px;
}
</style>
